module.exports = __webpack_public_path__ + "static/media/push.997d17c0.svg";